module.exports = __webpack_public_path__ + "img/tab02.833f51ce.png";